import './vendor';
import lazyLoading from './modules/lazyLoading';
import Vivus from '../../node_modules/vivus/dist/vivus.js';
require('/src/js/vendor/magnific/jquery.magnific-popup.min.js')
import NativejsSelect from 'nativejs-select'
require('../../node_modules/jquery-background-video/jquery.background-video.js')
require('../../node_modules/isotope-layout/dist/isotope.pkgd.js')

lazyLoading.init();

$('.my-background-video').bgVideo({
	fullScreen: false, // Sets the video to be fixed to the full window - your <video> and it's container should be direct descendents of the <body> tag
	fadeIn: 500, // Milliseconds to fade video in/out (0 for no fade)
	pauseAfter: 0, // Seconds to play before pausing (0 for forever)
	fadeOnPause: false, // For all (including manual) pauses
	fadeOnEnd: true, // When we've reached the pauseAfter time
	showPausePlay: false, // Show pause/play button
	pausePlayXPos: 'right', // left|right|center
	pausePlayYPos: 'top', // top|bottom|center
	pausePlayXOffset: '15px', // pixels or percent from side - ignored if positioned center
	pausePlayYOffset: '15px' // pixels or percent from top/bottom - ignored if positioned center
});

$('.products__grid').isotope({
	// options...
	itemSelector: '.products__griditem',
	percentPosition: true,
	masonry: {
	  	columnWidth: '.products__griditem'
	}
});



$(".filter__openfilter ").click(function() {
	$(this).toggleClass("is-active");
	$(".filter__variants").toggleClass("is-active");
});


$('.form__input').blur(function(){
	if($(this).val().length !== 0) {
		  $(this).addClass('is-filled');
	}
	else {
		  $(this).removeClass('is-filled');
	}
});



$(".header__menu").click(function() {
	$("body").addClass("overflow");
	$(".mobilemenu").addClass("is-active");
});

$(".mobilemenu__btn").click(function() {
	$("body").removeClass("overflow");
	$(".mobilemenu").removeClass("is-active");
});



$("#view1").click(function() {
	$(this).addClass("is-active");
	$("#view2").removeClass("is-active");
	$(".products__container").removeClass("products__container--view2");
});
$("#view2").click(function() {
	$(this).addClass("is-active");
	$("#view1").removeClass("is-active");
	$(".products__container").addClass("products__container--view2");
});


$('.event-slider').slick({
	dots: false,
	speed: 1000,
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	fade: true,
	cssEase: 'linear',
	prevArrow: '<button type="button" class="btn-slider prev"><svg><use xlink:href="./images/sprites.svg#prev"></use></svg></button>',
	nextArrow: '<button type="button" class="btn-slider next"><svg><use xlink:href="./images/sprites.svg#next"></use></svg></button>',
});


$('.suvenirs-slider').slick({
	dots: false,
	speed: 500,
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	fade: true,
	cssEase: 'linear',
	prevArrow: '<button type="button" class="btn-slider prev"><svg><use xlink:href="./images/sprites.svg#prev"></use></svg></button>',
	nextArrow: '<button type="button" class="btn-slider next"><svg><use xlink:href="./images/sprites.svg#next"></use></svg></button>',
});


$('.slider').slick({
	dots: false,
	speed: 0,
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	variableWidth: true,
	// autoplay: true,
	// autoplaySpeed: 3000,
	pauseOnHover: false,
	// fade: true,
	// cssEase: 'linear',
	swipe: false,
	prevArrow: '<button type="button" class="btn-slider prev"><svg><use xlink:href="./images/sprites.svg#prev"></use></svg></button>',
	nextArrow: '<button type="button" class="btn-slider next"><svg><use xlink:href="./images/sprites.svg#next"></use></svg></button>',
});

/*Magnific модальное окно */
$('.popup-with-form').magnificPopup({
	type: 'inline',
	preloader: false,
	focus: '#name',
	mainClass: 'mfp-fade',
	callbacks: {
		beforeOpen: function() {
			if($(window).width() < 700) {
				this.st.focus = false;
			} else {
				this.st.focus = '#name';
			}
		}
	}
});

//E-mail Ajax Send
//Documentation & Example: https://github.com/agragregra/uniMail
$(".form").submit(function() { //Change
	var th = $(this);
	$.ajax({
		type: "POST",
		url: "assets/build/mail.php", //Change
		data: th.serialize()
	}).done(function() {
		$(".done-w").fadeIn();
		setTimeout(function() {
			// Done Functions
			$(".done-w").fadeOut();
			$.magnificPopup.close();
			th.trigger("reset");
		}, 3000);
	});
	return false;
});

/*Стилизованный Select*/
new NativejsSelect({
	selector: '.customSelect'
  });



$(".tabs-block__item").not(":first").hide();
$(".tabs-block .tabs-block__tab").click(function() {
	$(".tabs-block .tabs-block__tab").removeClass("active").eq($(this).index()).addClass("active");
	$(".tabs-block__item").hide().eq($(this).index()).fadeIn()
}).eq(0).addClass("active");



$('.product-slider').slick({
	dots: true,
	speed: 1000,
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	appendDots: $('.slick-dots-custom'),
	prevArrow: '<button type="button" class="btn-slider prev"><img src="/assets/build/images/sprites/svg/prev.svg"></button>',
	nextArrow: '<button type="button" class="btn-slider next"><img src="/assets/build/images/sprites/svg/next.svg"></button>',
	asNavFor: '.product-slider-thumb',
});

$('.product-slider-thumb').slick({
	slidesToShow: 3,
	slidesToScroll: 1,
	vertical: true,
	asNavFor: '.product-slider',
	focusOnSelect: true,
	arrows: false,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				vertical: false,
		    }
		}
	]
});


$(".scroll").on("click","a", function (event) {
    // исключаем стандартную реакцию браузера
    event.preventDefault();

    // получем идентификатор блока из атрибута href
    var id  = $(this).attr('data-scroll-to'),

    // находим высоту, на которой расположен блок
        top = $(id).offset().top;

    // анимируем переход к блоку, время: 800 мс
    $('body,html').animate({scrollTop: top}, 800);
});


/*Magnific галерея*/
$('.popup-gallery').magnificPopup({
	delegate: 'a',
	type: 'image',
	tLoading: 'Загрузка изображения #%curr%...',
	mainClass: 'mfp-fade mfp-img-mobile',
	gallery: {
		enabled: true,
		navigateByImgClick: true,
		preload: [0,1] // Will preload 0 - before current, and 1 after the current image
	},
	image: {
		tError: '<a href="%url%">Изображение #%curr%</a> не загружено.',
		titleSrc: function(item) {
			return '';
		}
	}
});


$('.popup').magnificPopup({
	type: 'image',
	closeOnContentClick: true,
	closeBtnInside: false,
	fixedContentPos: true,
	mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
	image: {
		verticalFit: true
	},
	zoom: {
		enabled: true,
		duration: 300 // don't foget to change the duration also in CSS
	}
});
